export default "__VITE_ASSET__BX5oNYBy__"